const tipoFormaPago = [
  { id: '1', nombre: 'Efectivo' },
  { id: '2', nombre: 'Tarjeta' },
  { id: '3', nombre: 'Transferencia' },
  { id: '4', nombre: 'Cheque' },
];

export default tipoFormaPago
